import { Activity } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function OnChainEventNode({ id, data, selected }) {
  const summary = data.network ? `${data.network} — ${data.eventName || 'Event'}` : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.triggers}
      icon={Activity}
      label={data.label}
      hasInput={false}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
